import _ from 'lodash'
import moment from "moment";
import I18n from 'lib/i18n/i18n';
import WorthyApi from "lib/api/worthyApi";
import {FacebookUser} from "./SegmentHelper";
export const googleApiKey = process.env.googleApiKey;
import { convertDateTimeToLocalTime } from 'helpers/dateTimeHelper';
import cookie from 'react-cookie';
import { operations } from '@worthy-npm/worthy-shared-content';

const worthyAddr = operations.worthyOfficeMain.address;


const formatNumber = (price, c, d, t) => {
    // TODO: this is unreadable
    var n = price, c = isNaN(c = Math.abs(c)) ? 2 : c, d = d == undefined ? "," : d, t = t == undefined ? "." : t, s = n < 0 ? "-" : "", i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

export function isProduction() {
    return __ENV__ === 'production';
}

export function isQA() {
    return __ENV__ === 'qa';
}

const getSubDomainPrefix = () => window.location.host.split('.')[0];

const isReverseProxy = () => (['www', 'qa', 'demo', 'london', 'staging', 'rio'].includes(getSubDomainPrefix()));

export const getEnvName = () => {
    if (typeof window === 'undefined') return __ENV__;
    const subDomainPrefix = getSubDomainPrefix();
    if (subDomainPrefix.includes('local')) return 'development';

    if (isReverseProxy()) {
        if (subDomainPrefix === 'www') return 'production';
        return subDomainPrefix;
    }

    // if one of our online test environments
    if (subDomainPrefix.includes('-')) return subDomainPrefix.split('-')[1];
    return 'production';
};

/**
 * this function returns true if you are inside an iframe
 * @returns {boolean}
 */
export function isIframe(){
    return window.self !== window.top;
}

export function isInstagramBrowser() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return (/Instagram/.test(userAgent));
}

export function isMobile() {
    let useragent = null
    if ( typeof window === 'undefined' ) { // assuming we have window on the server side and not on the server side
        // expected global.useragent to exist since we updated it in routes.js
        useragent = global ? global.useragent : undefined
    } else {
        useragent = navigator.userAgent||navigator.vendor||window.opera
    }
    let check = false;
    if ( useragent ) { //eslint-disable-next-line
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(useragent);
    }
    return check;
}

export function isIos() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream);
}

export function isIphone() {
    return isMobile() && isIos();
}

export function isDefaultPhone(phone) {
    return phone === '0000000000';
}

export function isFakePhone(phone) {
    return ['0000000000', '0000000001', '0000000002'].includes(phone);
}
export function isTablet() {
    return !isMobile() && window.innerWidth <= 1024 && (window.innerWidth >= (window.innerHeight > window.innerWidth ? 481 : 768))
}

let savedUvid = null;

export function storeUvid(uvid) {
    console.log('storeUvid', uvid);
    savedUvid = uvid;
    localStorage.setItem('uvid', uvid);
}

export function getUvid() {
    if (savedUvid) {
        return savedUvid;
    } else if (typeof window !== 'undefined') {
        // try the local storage
        const uvid = localStorage.getItem('uvid');
        if (uvid) {
            savedUvid = uvid;
            return uvid;
        }
        // try the cookie
        const cookieUvid = cookie.load('uvid');
        if (cookieUvid) {
            savedUvid = cookieUvid;
            return cookieUvid;
        }
    }
    return null;
}

export function addUvidToUrl(url) {
    const uvid = getUvid();
    if (uvid) {
        const urlObj = new URL(url);
        urlObj.searchParams.set('uvid', uvid);
        return urlObj.toString();
    }
    return url;
}

// TODO: why is this calced in real time and not defined in setting file?
export function appDomain() {
    // WORTHY-10805 - no hard coded worthy urls
    if ( typeof __APP_URL__ !== 'undefined' ) {
        return __APP_URL__.split('://')[1]
    }
    switch (__ENV__) {
        case "staging":
            return `app-dev.worthy.com`;
            break;
        case "qa":
            return `app-qa.worthy.com`;
            break;
        case "demo":
            return `app-demo.worthy.com`;
            break;
        case "london":
            return `app-london.worthy.com`;
            break;
        case "production":
            return `app.worthy.com`;
            break;
        case "development":
            return (__LOCALHOST__ === 'true') ? 'localhost:9001' : `localapp.worthy.com:9001`;
            break;
        default:
            return __reqDomain__;
            break;
    }
}

// TODO: why is this calced in real time and not defined in setting file?
// TODO: the path param is superfluous, just concat in caller
export function rootUrlNoParams(path = '') {
    let ROOT_URL = '';

    // WORTHY-10805 - no hard coded worthy urls
    if (typeof __SITE_URL__ !== 'undefined') {
        ROOT_URL = `${__SITE_URL__}${path}`
    } else {
        switch (__ENV__) {
            case "staging":
                ROOT_URL = `https://dev.worthy.com`;
                break;
            case "qa":
                ROOT_URL = `https://qa.worthy.com`;
                break;
            case "demo":
                ROOT_URL = `https://demo.worthy.com`;
                break;
            case "london":
                ROOT_URL = `https://london.worthy.com`;
                break;
            case "production":
                ROOT_URL = `https://www.worthy.com`;
                break;
            default:
                ROOT_URL = (__LOCALHOST__ === 'true') ? 'http://localhost:3000' : `http://local.worthy.com:3000`;
                break;
        }
        ROOT_URL = `${ROOT_URL}${path}`
    }
    return ROOT_URL;
}

export function rootUrl(path = '') {
    const ROOT_URL = rootUrlNoParams(path);
    return addUvidToUrl(ROOT_URL);
}


export function rootAPIUrl(path) {
    return rootUrlNoParams(`/api/v2/sellers${path}`);
}

export function appUrlNoParams(path = '') {
    let app_url = '';

    //WORTHY-10805 - no hard coded worthy urls
    if ( typeof __APP_URL__ !== 'undefined' ) {
        return `${__APP_URL__}${path}`
    }

    switch (__ENV__) {
        case "staging":
            app_url = `https://app-dev.worthy.com`;
            break;
        case "qa":
            app_url = `https://app-qa.worthy.com`;
            break;
        case "demo":
            app_url = `https://app-demo.worthy.com`;
            break;
        case "london":
            app_url = `https://app-london.worthy.com`;
            break;
        case "production":
            app_url = `https://app.worthy.com`;
            break;
        default:
            app_url = (__LOCALHOST__ === 'true') ?  `http://localhost:9001` : `http://localapp.worthy.com:9001`;
            break;
    }
    return `${app_url}${path}`
}

export function appUrl(path = '') {
    const app_url = appUrlNoParams(path);
    return addUvidToUrl(app_url);
}

export function sellerDashboardUrlNoParams(path = '') {
    let sellerDashboardUrl = '';

    //WORTHY-10805 - no hard coded worthy urls
    if ( typeof __SELLERDASHBOARD_URL__ !== 'undefined' ) {
        return `${__SELLERDASHBOARD_URL__}${path}`
    }

    switch (__ENV__) {
        case "staging":
            sellerDashboardUrl = `https://seller-dashboard-dev.worthy.com`;
            break;
        case "qa":
            sellerDashboardUrl = `https://seller-dashboard-qa.worthy.com`;
            break;
        case "demo":
            sellerDashboardUrl = `https://seller-dashboard-demo.worthy.com`;
            break;
        case "london":
            sellerDashboardUrl = `https://seller-dashboard-london.worthy.com`;
            break;
        case "production":
            sellerDashboardUrl = `https://seller-dashboard.worthy.com`;
            break;
        default:
            sellerDashboardUrl = (__LOCALHOST__ === 'true') ?  `http://localhost:5050` : `http://localseller-dashboard.worthy.com:5050`;
            break;
    }
    return `${sellerDashboardUrl}${path}`
}

export function sellerDashboardUrl(path = '') {
    const sellerDashboardUrl = sellerDashboardUrlNoParams(path);
    return addUvidToUrl(sellerDashboardUrl);
}

export function contentSiteBEUrl(path = '') {
    let content_site_be_url = '';

    if ( typeof __CONTENT_SITE_URL__ !== 'undefined' ) {
        return `${__CONTENT_SITE_URL__}${path}`;
    }

    switch (__ENV__) {
        case "staging":
            content_site_be_url = `https://contentbe-dev.worthy.com`;
            break;
        case "qa":
            content_site_be_url = `https://contentbe-qa.worthy.com`;
            break;
        case "demo":
            content_site_be_url = `https://contentbe-demo.worthy.com`;
            break;
        case "london":
            content_site_be_url = `https://contentbe-london.worthy.com`;
            break;
        case "production":
            content_site_be_url = `https://contentbe.worthy.com`;
            break;
        default:
            // content_site_url = `http://localhost:9020`;
            content_site_be_url = (__LOCALHOST__ === 'true') ?  `http://localhost:9020` : `http://localapp.worthy.com:9020`;
            break;
    }
    return `${content_site_be_url}${path}`;
}

export function contentSiteUrl(path = '') {
    return rootUrl(path)
}

export function segmentUrl(path = '') {
    let segment_url = '';

    //WORTHY-10805 - no hard coded worthy urls
    if ( typeof __SEGMENT_URL__ !== 'undefined' ) {
        return `${__SEGMENT_URL__}/${path}`
    }

    switch (__ENV__) {
        case "development":
            segment_url = `localhost:9004`;
            break;
        default:
            segment_url = location.host.replace('app','segment');
            break;
    }
    return `${location.protocol}//${segment_url}/${path}`
}

export function personalizerUrl(path = '') {
	let personalizer_url = ''

	//WORTHY-10805 - no hard coded worthy urls
	if ( typeof __PERSONALIZER_URL__ !== 'undefined' ) {
		return `${__PERSONALIZER_URL__}/${path}`
	}

	switch (__ENV__) {
		case "development":
			personalizer_url =(__LOCALHOST__ === 'true') ? `localhost:5001` : `local.worthy.com:5001`;
			break;
		default:
			personalizer_url = location.host.replace('app','personalizer');
			break;
	}
	return `${location.protocol}//${personalizer_url}/${path}`
}

export function authenticatorUrl(path) {
	let authenticator_url = ''

	if ( typeof __AUTHENTICATOR_URL__ !== 'undefined' ) {
		return `${__AUTHENTICATOR_URL__}/${path}`
	}

	switch (__ENV__) {
		case "development":
			authenticator_url = (__LOCALHOST__ === 'true') ? `localhost:6006` : `local.worthy.com:6006`;
			break;
		default:
			authenticator_url = location.host.replace('app','auth');
			break;
	}
	return `${location.protocol}//${authenticator_url}/${path}`
}

export function dataCollectorUrl(path = '') {
	let dc_url = ''

	//WORTHY-10805 - no hard coded worthy urls
	if ( typeof __DATA_COLLECTOR_URL__ !== 'undefined' ) {
		return `${__DATA_COLLECTOR_URL__}/${path}`
	}

	switch (__ENV__) {
		case "development":
			dc_url = (__LOCALHOST__ === 'true') ? `localhost:5002` : `local.worthy.com:5002`;
			break;
		default:
			dc_url = location.host.replace('app','collect');
			break;
	}
	return `${location.protocol}//${dc_url}/${path}`
}

export function submissionFlowUrl(path = '') {
	let submission_flow_host = ''

	if ( typeof __SUBMISSION_FLOW_URL__ !== 'undefined' ) {
		return `${__SUBMISSION_FLOW_URL__}/${path}`
	}

	switch (__ENV__) {
		case "development":
            submission_flow_host = (__LOCALHOST__ === 'true') ? `localhost:8001` :`localsubmit.worthy.com:8001`;
			break;
		default:
            submission_flow_host = location.host.replace('app','submit');
			break;
	}
	return addUvidToUrl(`${location.protocol}//${submission_flow_host}/${path}`)
}

export function marketPlaceUrl(path = '') {
    let market_place_url = '';

    if ( typeof __MARKET_PLACE_URL__ !== 'undefined' ) {
        return `${__MARKET_PLACE_URL__}/${path}`;
    }

    switch (__ENV__) {
        default:
            market_place_url =  'shop.worthy.com';
            break;
    }
    return `https://${market_place_url}/${path}`;
}

export function BlogUrl(path = '') {
    let blog_url = '';

    if ( typeof __BLOG_URL__ !== 'undefined' ) {
        return `${__BLOG_URL__}/${path}`;
    }

    switch (__ENV__) {
        default:
            blog_url =  'blog.worthy.com';
            break;
    }

    return addUvidToUrl(`https://${blog_url}/${path}`);
}

export function waveUrl(path= '', isApi = true) {
    let wave_url = ''

    if (process.env.WORTHY_WAVE_URL) {
        return `${process.env.WORTHY_WAVE_URL}${isApi ? '/api' : ''}/${path}`;
    }

    switch (__ENV__) {
        case "development":
            wave_url = 'localhost:3007/api';
            break;
        case "qa":
            wave_url = 'worthy-wave-qa.herokuapp.com/api'
            break;
        case "production":
            wave_url = 'ipawn-ape.herokuapp.com/api'
            break;
        default:
            wave_url = `worthy-wave-${__ENV__}.herokuapp.com/api`;
            break;
    }
    return `${location.protocol}//${wave_url}/${path}`
}

export function signNowServiceUrl(path){
  let sign_now_service_url = ''

  switch (__ENV__) {
      case "development":
          sign_now_service_url = 'localhost:6008';
          break;
      case "london":
          sign_now_service_url = 'esign-london.worthy.com';
          break;
      case "qa":
          sign_now_service_url = 'esign-qa.worthy.com'
          break;
      case "production":
          sign_now_service_url = 'esign.worthy.com'
          break;
      default:
          sign_now_service_url = `esign-${__ENV__}.worthy.com`;
          break;
  }
  return `${location.protocol}//${sign_now_service_url}/${path}`
}

export function imageUrl(imagePath) {
    let lastIndexOfSlash = imagePath.lastIndexOf('/');
    if (lastIndexOfSlash < 0) {
        return `${__CDN__}/assets/images/${__ASSETS_HASH__}${imagePath}`;
    } else {
        let modified = `${imagePath.slice(0, lastIndexOfSlash+1)}${__ASSETS_HASH__}${imagePath.slice(lastIndexOfSlash+1)}`;
        return `${__CDN__}/assets/images/${modified}`;
    }
}

export function preloadImages(images) {
    if(__CLIENT__){
        window.onload = ()=> {
            _.map(images, (url) => {
                document.createElement("img").setAttribute('src', imageUrl(url));
            });
        };
    }
}

export function isJewelers(Session) {
    return Session.isLoggedIn && Session.userData.business;
}

export function dollars(price) {
    return `$${formatNumber(parseInt(price), 2, ".", ",").toString()}`;
}

const wait = ms => new Promise(res => setTimeout(res, ms));

export async function retriable(cb, args, max) {
    async function fetchRetry(retries) {
        try {
            if (retries > 0) {
                await wait(4 ** retries * 10);
            }
            const res = await cb(args);

            const dateTime = _.get(res, 'data.data');
            if (!_.isEmpty(dateTime)) {
                return res;
            } else {
                throw 'Bubbling again';
            }
        } catch (e) {
            if (retries < max) {
                return fetchRetry(retries + 1);
            } else {
                console.warn('Max retries reached. Bubbling the error up');
                throw e;
            }
        }
    }

    return fetchRetry(0);
}

export function dollarsWithoutCents(price) {
    return `$${formatNumber(parseInt(price), 0, ".", ",").toString()}`;
}

export function roundNumber(num, dec=0) {
    let val = dec === 0 ? 1 : Math.pow(10, dec)
    return Math.round ((num + Number.EPSILON) * val) / val
}

// use this function from now on instead of dollarsWithoutCents due to parseFloat
export function roundedPrice(price) {
    return `$${formatNumber(parseFloat(price), 0, ".", ",").toString()}`;
}

export function priceWithoutDollar(price) {
    return `${formatNumber(parseInt(price), 0, ".", ",").toString()}`;
}

export function priceOnlyDigits(price) {
    return `${formatNumber(parseInt(price), 0, ".", "").toString()}`;
}

export function percentageOnValues(newValue, oldValue) {

    return `${parseInt(((newValue/oldValue - 1)*100)).toString()}`;
}

export function diffOnValues(newValue, oldValue) {
    return `${dollarsWithoutCents(parseInt((newValue - oldValue)))}`;
}

export function formatPhone(phone){
    return `(${phone.slice(0,3)}) ${phone.slice(3,6)}-${phone.slice(6)}`;
}

export function getOffset(elem) {
    // TODO: var, no var, var, no var...
    var box = elem.getBoundingClientRect();
    var doc = elem.ownerDocument,
        docElem = doc.documentElement;
    var body = doc.body,
        win = doc,
        clientTop  = docElem.clientTop  || body.clientTop  || 0,
        clientLeft = docElem.clientLeft || body.clientLeft || 0,
        scrollTop  = win.pageYOffset || body.scrollTop,
        scrollLeft = win.pageXOffset || body.scrollLeft,
        top  = box.top  + scrollTop  - clientTop,
        left = box.left + scrollLeft - clientLeft;
    return { top: top, left: left };
}

export function enableBtn(ref)
{
    ref.removeAttribute("disabled");
}

export function disableBtn(ref)
{
    ref.setAttribute("disabled", "disabled");
}

export function dataAutomationAttr(automationId) {
    return automationId && automationId.replace(/\ |-/g, "-").replace("/",'').toLowerCase() || null;
}

/**
 * this function will recieve an event name and dispatch it into the document.
 * this is a vital function for the embedded submission form widget, without those events the iframe will not resize properly
 * @param eventName
 */
export function widgetEventDispatcher(eventName){
    if(isIframe()){
        document.dispatchEvent(new Event(eventName));
    }
}

export function capitalize_words(str)
{
    return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}

export function env(name) {
    if (typeof appGlobals !== 'undefined') {
        // eslint-disable-next-line no-undef
        return appGlobals[name]
    }
}

// Version of Listing draft with shipping kit experiment
export const LD_SK_EXP_VERSION = '2.3';

// Version of Light Listing draft with shipping kit experiment
export const LL_SK_EXP_VERSION = '1.1';

//Shipment methods
export const SHIPMENT_METHOD = {
    'Pickup': 0,
    'Drop Off': 1,
    'None': 2,
    'Pickup No Show': 3,
    'In-Person Drop Off': 4,
};

export const MIN_SIMILAR_ITEMS_TO_SHOW = 2;
// Step for SSSF
export const STEP_ADDRESS = 'address';
export const STEP_PICKUP = 'pickup';
export const STEP_MESSAGE = 'message';
export const STEP_PHONE = 'phone';

// Shipment information DOM element ID
export const SHIPMENT_DOM_ID = 'shipment-information';

//Worthy address
export const WORTHY_ADDRESS = worthyAddr.street + ', ' + worthyAddr.floor + ', ' + worthyAddr.city + ', ' +
    worthyAddr.state + ' ' + worthyAddr.zip;
// Item states
export const SUBMISSION = 'submission';
export const VALIDATION_NEEDED = 'validation_needed';
export const ESTIMATION_READY = 'estimation_ready';
export const SHIPPING = 'shipping';
export const PENDING_AUCTION = 'pending_auction';
export const PENDING_SALE = 'pending_sale';
export const RETURN_PAYMENT_WAITING = 'return_payment_waiting';
export const RETURN_PENDING = 'return_pending';
export const RETURN_SCHEDULED = 'return_scheduled';
export const ON_HOLD = 'on_hold';
export const PRE_INVENTORY = 'pre_inventory';
export const INVENTORY = 'inventory';
export const SALE_SCHEDULED = 'sale_scheduled';
export const EVALUATION_BID = 'evaluation_bid';
export const EVALUATION_READY = 'evaluation_ready';
export const EVALUATION_BID_ASSORTED = 'evaluation_bid_assorted';
export const SHIPPED_BACK_TO_SELLER = 'shipped_back_to_seller';
export const BIDDING_FINISHED = 'bidding_finished';
export const DONE = 'done';
export const DELIVERED = 'delivered';
export const ESTIMATION_BID = 'estimation_bid';
export const ESTIMATION_NEEDED = 'estimation_needed';

// Bundle states
export const PICKUP_WAITING = 'pickup_waiting';
export const ADDRESS_WAITING = 'address_waiting';
export const ESTIMATED = 'estimated';
export const EVALUATED = 'evaluated';
export const IN_TRANSIT = 'in_transit';
export const NEW = 'new';
export const UNPACKED = 'unpacked';
export const DONE_SOLD = 'done_sold';

// Bundle shipment methods
export const PICKUP_NO_SHOW = 'Pickup No Show';

// Value Categories

export const STANDARD = "Standard"
export const HIGH_VALUE = "High Value";
export const SUPER_EXPENSIVE = "Super Expensive";

export const isShipBack = (item) => {
  if (!item) {
    return false;
  }
  return [RETURN_PAYMENT_WAITING, RETURN_PENDING, RETURN_SCHEDULED].includes(item.workflow_state);
 }

export const LS = typeof window === 'undefined' ? {
    remove(){},
    get(){},
    set(){},
} : {
    remove(key) {
        try {
            localStorage.removeItem(key);
        } catch (e) {
            console.error(e);
        }
    },
    get(key) {
        try {
            return localStorage.getItem(key) === 'undefined' ? undefined : JSON.parse(localStorage.getItem(key));
        } catch (e) {
            console.error(e);
        }
    },
    set(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            console.error(e);
        }
    }
}; // Fix for the error in server rendering "localStorage is undefined"

export const SS = typeof window === 'undefined' ? {
    remove(){},
    get(){},
    set(){},
} : {
    remove(key) {
        try {
            sessionStorage.removeItem(key);
        } catch (e) {
            console.error(e);
        }
    },
    get(key) {
        try {
            return sessionStorage.getItem(key) === 'undefined' ? undefined : JSON.parse(sessionStorage.getItem(key));
        } catch (e) {
            console.error(e);
        }
    },
    set(key, value) {
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            console.error(e);
        }
    }
};

export const splitArrayToLines = (arr =[], itemsPerLine = 2) => {
    let temp_idx = 0;
    let res = [];

    if (itemsPerLine <= 0) {
        console.error('Improper items per line parameter');
        return arr;
    }

    arr.forEach((item, idx) => {
        if (res[temp_idx]) {
            res[temp_idx].push(item)
        } else {
            res[temp_idx] = [item]
        }
        if ((idx + 1) % itemsPerLine === 0) {
            temp_idx += 1
        }
    });

    return res;
};
export const ITEM_TYPE_TO_RECENTLY_SOLD_ITEMS_URL_MATCH = {
    'ring': 'rings',
    'loose diamond': 'loose-diamonds'
};

export const JEWELRY_FOR_EXPERIMENTS = ['loose diamond', 'ring'];
export const EXTRA_HV_CATEGORIES = ['Ultra Expensive', 'Super Expensive']
export const OPENED_SCHEDULE_MODAL = "OPENED_SCHEDULE_MODAL"

// User Behavior
export const CLICKED_EDIT_PHOTOS = "Pressed edit photos";

moment.updateLocale('en', {
    calendar: {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        lastDay: 'dddd',
        lastWeek: 'dddd',
        sameElse: 'dddd'
    }
});

export const TIME_ZONE = 'America/New_York';


export const isUltraVIP = (itemValueCategory) => {
 return EXTRA_HV_CATEGORIES.map(s=> s.toLowerCase()).includes(itemValueCategory.toLowerCase())
}

export const getSlots = (pickupAvailability, localTime, ignoreLocalTime = false) => {
    if (!pickupAvailability || !pickupAvailability.length || !localTime) {
        console.error(`missing required field pickupAvailability: ${pickupAvailability} or localTime: ${localTime}`);
        return [];
    }

    const clientLocalTime = !ignoreLocalTime && convertDateTimeToLocalTime(TIME_ZONE, moment()).format()

    localTime = clientLocalTime || localTime

    function nextSlotIsSameDay(slots, readyTimestamp){
        return moment(slots[slots.length - 1].readyTimestamp).day() == moment(readyTimestamp).day()
    }

    const PICKUP_START_TIME = 11;
    const MIN_PICKUP_START_TIME_THERSHOLD = 9;
    const FEDEX_OFFICIAL_START_TIME = 13;
    const MAX_SCHEDULE_PICKUP_HOURS = 48;
    const maxSchedulePickupTime = moment(localTime).add(MAX_SCHEDULE_PICKUP_HOURS, 'hours');

    let slots = [];
    const userLocalTime = moment(localTime).utcOffset(localTime);

    pickupAvailability.forEach((pickup) => {
        const cutTime = pickup.cut_off_time.split(':');
        let cutOffTimeHour = parseInt(cutTime[0]);

        const cutOffTime = cutOffTimeHour;
        const leftMinutes = cutTime[1];
        const accessTime = pickup.access_time;
        const date = pickup.date;


        // default start time is 11 if cutOffTime < 13 min start time is 10
        const startTime = cutOffTime <= FEDEX_OFFICIAL_START_TIME ? MIN_PICKUP_START_TIME_THERSHOLD : PICKUP_START_TIME;

        // if date is today we need to check that the time has not passed
        let time = moment(date).day() === userLocalTime.day() && userLocalTime.hour() >= startTime ? userLocalTime.hour() + 1 : startTime;

        let pickupSlot = moment(`${date} ${userLocalTime.format('Z')}`, "YYYY-MM-DD Z").utcOffset(localTime);
        pickupSlot.set('hour', time)

        let readyTimestamp = moment(pickupSlot);
        let companyCloseTime = moment(pickupSlot).add(accessTime, 'seconds');

        // generate available slots for time between startTime - cutOffTime if companyCloseTime is in the next 48 hours
        while (companyCloseTime.hour() <= cutOffTime) {
            if(moment(companyCloseTime).isAfter(maxSchedulePickupTime) && slots.length && !nextSlotIsSameDay(slots, readyTimestamp)) {
                return slots;
            }
                // add left minutes
            if (companyCloseTime.hour() == cutOffTime && companyCloseTime.minutes() < leftMinutes) {
                companyCloseTime.set('minute', leftMinutes)
            }
            // exclude windows of passed time - may happen when user has an old window and didn't refresh to get updated availability options from backend
            // exclude windows too close to user current time
            if (ignoreLocalTime || (readyTimestamp.isAfter(userLocalTime) && companyCloseTime.isAfter(userLocalTime.add(2, 'hours')) ) ) {
                let slot = {
                    dayText: readyTimestamp.calendar(),
                    readyTimestamp: readyTimestamp.format('YYYY-MM-DDTHH:mm:ss'),
                    timeText: `${readyTimestamp.format('h:mma')} - ${companyCloseTime.format('h:mma')}`,
                    companyCloseTime: companyCloseTime.format('HH:mm:ss'),
                    earlySlot: readyTimestamp.hour() < FEDEX_OFFICIAL_START_TIME
                };
                slots.push(slot);
            }
            let futureTime = moment(companyCloseTime).add(accessTime, 'seconds');
            if (companyCloseTime.hour() < cutOffTime && futureTime.hour() > cutOffTime) {
                companyCloseTime = moment(companyCloseTime).set('hour', cutOffTime);
                readyTimestamp = moment(companyCloseTime).subtract(accessTime, 'seconds');
            }
            else {
                readyTimestamp = moment(companyCloseTime);
                companyCloseTime = futureTime;
            }
        }
    });
    return slots;
};

export const requestShippingKitPopupText = (shipment_method) => {
    if (![
        SHIPMENT_METHOD['Drop Off'],
        SHIPMENT_METHOD['Pickup']
    ].includes(shipment_method)) return '';
    return I18n.getString(`shippingKit::popup::text::${shipment_method === SHIPMENT_METHOD['Drop Off'] ? 'dropOff' : 'pickUp'}`)
};

export const getPreviousMonday = (predefinedDate) => {
    const date = predefinedDate || new Date();
    const day = date.getDay();
    let prevMonday;

    prevMonday = new Date().setDate(date.getDay() === 0 ? date.getDate() - 7 : date.getDate() - day);

    return new Date(prevMonday);
};

export const getOrdinalNumber = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const INSURANCE_CERTIFICATE_LINK = process.env.INSURANCE_CERTIFICATE

export const getSegments = (item, ADO) => {
    const medium = _.get(ADO, 'user.realSource.medium');
    const source = _.get(ADO, 'user.realSource.source');

    return WorthyApi.getSegments(FacebookUser(medium, source)).then(results => results[0].data[0])
        .catch((res) => 'null')	//TODO: fix for segments as array // if we don't have access to segment assume there are no segments and use defaults.
};

export const p13nServiceDecisions = {
    listingDraft: 'listingDraft',
    lightListingDraft: 'lightListingDraft',
    hvCui: 'hvCui',
    hybridHvCui: 'hybridHvCui',
    hybridCui: 'hybridCui',
    cui: 'cui',
    default: 'default'      // returned by the reducer when cannot communicate with the service.
};

export const DIRECTIONS = {
    LEFT: 'left',
    RIGHT: 'right',
};

export const EXPERTS_ROUTES = [
    'learn'
]

export const chatBotKind = (item, user) => {
    return user && user.last_name === "" && !item.high_value_estimation ? "missingDetails" : (item.item_type === 'watch' ? 'watch' :
        ((item.high_value_estimation || item.auto_reestimate) ? 'highValue' : 'standard'))
}

export const versionOfHvCui = (P13N, ChatBot) => {
    return P13N && P13N.preShipmentUi === p13nServiceDecisions.hybridHvCui ? ChatBot.conversationFlow.highValue[1].version : ChatBot.conversationFlow.highValue[0].version
}

export const getItemLink = (item) => {
    return item.public_id ? `/item/${item.public_id}` : `/multiple_jewelry/${item.id}`
}

export const visitedWelcomePage = () => {
    const visited = cookie.load('visited_new_welcome_experience')
    return visited === 'true'
}

export const parseShortenedDate = (date) => {
    const correctedDate = date.replace(/(\d{2}\/\d{2}\/\d{2})(\d:\d{2} [APM]+)/, '$1 $2');
    const someDate = moment.tz(correctedDate, 'MM/DD/YY h:mm A', 'UTC').local();
    return someDate.format('MM/DD/YY h:mm A');
}

export const getDateTimeDescription = (date, withTime = false) => {
    const time = date.clone().local().format('h:mm A');

    const timeDesc = date.calendar(null, {
        lastDay: `dddd `,
        sameDay: `[Today] [(${date.format('dddd')})] `,
        nextDay: `[Tomorrow] [(${date.format('dddd')})] `,
        nextWeek: 'dddd, MMM Do ',
        sameElse: 'dddd, MMM Do '
    }) + `${withTime ? ' at ' + time : ''}`;

    return timeDesc
}

export const isSubmissionRepositionExp = () => (isCookieBasedExp('opt_submission_flow_reposition'))

const expSlugs = [
    'opt_multi_item_flow',
    'opt_submission_flow_reposition',
]

export const isCookieBasedExp = (slug) => {
    const expCodeExists = expSlugs.includes(slug)
    if (!expCodeExists) {
        console.warn(`Such experiment not yet supported: ${slug}`)
        return false
    }
    if (cookie.load(slug)) {
        return cookie.load(slug) === 'true'
    }
    return false
}

export const statesForOnlineCancallation = [VALIDATION_NEEDED, ESTIMATION_BID, ESTIMATION_NEEDED, ESTIMATION_READY, SHIPPING]
